import React, { useState } from "react";
import { DataPoints } from "./DataPoints";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import NoData from "../../../../components/noData/noData";
import { NO_DATA_MESSAGE } from "../../../../app_constants";

const FutureDataToggle = ({
  label,
  cssKey,
  data,
  currencySymbol,
  noDataMessage = NO_DATA_MESSAGE,
  filterName,
  fileName,
  tableWrapperId = "client-info",
  dataPointsClassName,
  tableProps = {},
  addTooltip
}) => {
  const [show, setShow] = useState(false);
  const hasData = data?.tableInfo?.data?.length > 0;

  return (
    <>
      <div className={`toggle ${cssKey}-toggle`}>
        <p onClick={() => setShow(!show)}>{label}</p>
        <ToggleableButton isRadio isActive={show} title={cssKey} onClick={(val) => setShow(val)} />
      </div>
      <div className={`${cssKey}-content ${show ? "visible" : ""}`}>
        {hasData ? (
          <>
            <div className={dataPointsClassName || ""}>
              <DataPoints dataPoints={data?.dataPoints} currencySymbol={currencySymbol} />
            </div>
            <TableWithCustomSearch
              data={data.tableInfo.data}
              colHeaders={data.tableInfo.colHeaders}
              columns={data.tableInfo.columns}
              filterName={filterName}
              showCount={false}
              tableWrapperId={tableWrapperId}
              fileName={fileName}
              {...tableProps}
              {...(addTooltip && {
                customFn: (header, formattedValue) => addTooltip(header, formattedValue)
              })}
            />
          </>
        ) : (
          <NoData message={noDataMessage} />
        )}
      </div>
    </>
  );
};

export default FutureDataToggle;
